import moment from 'moment';
import { humanize } from 'underscore.string';
import React from 'react';
import { Translation } from 'react-i18next';
import { sluggify } from '../../../utils/localization/utils';
import { AUTOMATED_PAYMENT_EVENTS } from 'constants/accounting';
class HistoryTable extends React.Component {
    getDescription(ev) {
        var _a;
        if (ev.data && ev.data.human && ev.user) {
            return (React.createElement(Translation, null, (t, { i18n }) => (React.createElement(React.Fragment, null, t('ACCOUNTING_AUDIT_EVENT', {
                event: ev.type && ev.type === "rpa-update" ? ev.event : t(sluggify(humanize(ev.event))),
                user: ev.user,
            })))));
        }
        if (AUTOMATED_PAYMENT_EVENTS.includes(ev.event) &&
            ((_a = ev === null || ev === void 0 ? void 0 : ev.data) === null || _a === void 0 ? void 0 : _a.automated_payment_status_event)) {
            return ((React.createElement(Translation, null, (t) => {
                var _a;
                return (React.createElement(React.Fragment, null,
                    t(sluggify(ev.event)),
                    React.createElement("div", { "data-testid": "div-8a1b6c65" }, `${t('AMOUNT')}: ${(_a = ev === null || ev === void 0 ? void 0 : ev.data) === null || _a === void 0 ? void 0 : _a.amount}`)));
            })));
        }
        return (React.createElement(Translation, null, (t, { i18n }) => React.createElement(React.Fragment, null, ev.type && ev.type === "rpa-update" ? ev.event : t(sluggify(humanize(ev.event))))));
    }
    render() {
        const events = this.props.data;
        const type = this.props.type;
        if (events.length === 0) {
            return ((React.createElement(Translation, null, (t, { i18n }) => (React.createElement("h5", { "data-testid": "h5-ee121e38", className: "ml-6" }, t('NO_EVENTS_RECORDED', { type }))))));
        }
        const history = [...events].reverse().map((ev, index) => {
            return ((React.createElement(Translation, null, (t, { i18n }) => (React.createElement("tr", { "data-testid": `tr-67b9bad1-${index}`, key: ev._id },
                React.createElement("td", { "data-testid": `td-e3fd6831-${index}` }, this.getDescription(ev)),
                React.createElement("td", { "data-testid": `td-ba7ed5ce-${index}` }, ev.user || t('UNKNOWN_USER')),
                React.createElement("td", { "data-testid": `td-a811adfb-${index}` }, moment(ev.timestamp).format('LLLL')))))));
        });
        return ((React.createElement(Translation, null, (t, { i18n }) => (React.createElement("div", { "data-testid": "div-954cad61", className: "px-4 py-5 sm:px-6 overflow-x-scroll" },
            React.createElement("table", { "data-testid": "table-8b2e37d2", className: "default-table" },
                React.createElement("thead", { "data-testid": "thead-f0114464" },
                    React.createElement("tr", { "data-testid": "tr-7680c5bb" },
                        React.createElement("th", { "data-testid": "th-971a159e" }, t('EVENT', { count: 1 })),
                        React.createElement("th", { "data-testid": "th-4b7456fd" }, t('TRIGGERED_BY')),
                        React.createElement("th", { "data-testid": "th-279e32a3" }, t('TIME')))),
                React.createElement("tbody", { "data-testid": "tbody-e9cadd88" }, history)))))));
    }
}
export default HistoryTable;
